module.exports = __webpack_public_path__ + "static/img/gaozhonglishi11.5271eb28.jpg";